/* add scripts here */
$(document).ready(function() {
  var $rows = $('.colony_miner_comparision--table-row').not('.colony_miner_comparision--table-row-header');
  $rows.sort(function(a, b) {
    var nameA = $(a).data('product-name').toLowerCase();
    var nameB = $(b).data('product-name').toLowerCase();
    return nameA.localeCompare(nameB);
  });
  $('.colony_miner_comparision--table-row-header').after($rows);
});